/**
 * @ngInject
 */

function Tracking() {
    var api = {};

    api.trackPage = function trackPage(path){
        if(typeof ga === "function"){
            ga('send', 'pageview', path);
        } else {
            console.warn("ga is not defined. GA data is not tracked:\nC: "+path);
        }
    }

    api.trackEvent = function trackEvent(category, action, label){
        if(typeof ga === "function"){
            ga('send', 'event', category, action, label);
        } else {
            console.warn("ga is not defined. GA data is not tracked:\nC: "+category+"\nA: "+action+"\nL: "+label);
        }
    }

    api.setDimension = function setDimension(dimension, value){
        // console.log("SET DIMENSION: ",dimension,value)
        if(typeof ga === "function"){
            ga('set', dimension, value);
        } else {
            console.warn("ga is not defined. GA dimension not set:\nD: "+dimension+"\nV: "+value);
        }
    }

    return api;
}